import BaseConfig from './Base'
import AnchorTabs from './AnchorTabsConfig'
import ProductList from './ProductList'
import ImageBox from './ImageBoxConfig'
import VideoBox from './VideoBox'
import TextBox from './TextBox'
import MixedBlocks from './MixedBlocks'
import CustomTitle from './CustomTitle'
import SearchBar from './SearchBar/index'
import Conference from './Conference/index'
import NoticeBar from './NoticeBar'
import CombinationList from './CombinationList'
import Block from './Block'
export default {
  BaseConfig,
  AnchorTabs,
  ProductList,
  ImageBox,
  VideoBox,
  TextBox,
  MixedBlocks,
  CustomTitle,
  SearchBar,
  Conference,
  NoticeBar,
  CombinationList,
  Block,
}
